import React, { useState } from 'react';
import '../CSS/NewsletterSignup.css';

const NewsletterSignup = () => {
  const [email, setEmail] = useState('');
  const [subscribed, setSubscribed] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');

    // Basic email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setError('Please enter a valid email address');
      return;
    }

    // Simulate subscription
    setTimeout(() => {
      setSubscribed(true);
      setEmail('');
      setTimeout(() => {
        setSubscribed(false);
      }, 3000);
    }, 500);
  };

  return (
    <div className="newsletter-signup">
      <div className="newsletter-content">
        <h3>Subscribe to Our Newsletter</h3>
        <p>Get updates on new products, special offers, and industry tips delivered to your inbox.</p>
        
        {subscribed ? (
          <div className="success-message">
            <span className="success-icon">✓</span>
            <p>Thank you for subscribing! Check your email for confirmation.</p>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="newsletter-form">
            <div className="form-group">
              <input
                type="email"
                placeholder="Enter your email address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="newsletter-input"
                required
              />
              <button type="submit" className="newsletter-button">Subscribe</button>
            </div>
            {error && <span className="error-message">{error}</span>}
            <p className="privacy-notice">
              We respect your privacy. Unsubscribe at any time.
            </p>
          </form>
        )}
      </div>
    </div>
  );
};

export default NewsletterSignup;
